var map = {
	"./ion-accordion_2.entry.js": [
		7518,
		2076,
		7518
	],
	"./ion-action-sheet.entry.js": [
		1981,
		2076,
		1981
	],
	"./ion-alert.entry.js": [
		1603,
		2076,
		1603
	],
	"./ion-app_8.entry.js": [
		2273,
		2076,
		2273
	],
	"./ion-avatar_3.entry.js": [
		9642,
		9642
	],
	"./ion-back-button.entry.js": [
		2095,
		2076,
		2095
	],
	"./ion-backdrop.entry.js": [
		2335,
		2335
	],
	"./ion-breadcrumb_2.entry.js": [
		8221,
		2076,
		8221
	],
	"./ion-button_2.entry.js": [
		7184,
		7184
	],
	"./ion-card_5.entry.js": [
		8759,
		8759
	],
	"./ion-checkbox.entry.js": [
		4248,
		4248
	],
	"./ion-chip.entry.js": [
		9863,
		9863
	],
	"./ion-col_3.entry.js": [
		1769,
		1769
	],
	"./ion-datetime-button.entry.js": [
		2569,
		6948,
		2569
	],
	"./ion-datetime_3.entry.js": [
		6534,
		6948,
		2076,
		6534
	],
	"./ion-fab_3.entry.js": [
		5458,
		2076,
		5458
	],
	"./ion-img.entry.js": [
		654,
		654
	],
	"./ion-infinite-scroll_2.entry.js": [
		6034,
		2076,
		6034
	],
	"./ion-input-otp.entry.js": [
		381,
		2076,
		381
	],
	"./ion-input-password-toggle.entry.js": [
		5196,
		2076,
		5196
	],
	"./ion-input.entry.js": [
		761,
		2076,
		761
	],
	"./ion-item-option_3.entry.js": [
		6492,
		2076,
		6492
	],
	"./ion-item_8.entry.js": [
		9557,
		2076,
		9557
	],
	"./ion-loading.entry.js": [
		8353,
		2076,
		8353
	],
	"./ion-menu_3.entry.js": [
		1024,
		2076,
		1024
	],
	"./ion-modal.entry.js": [
		9160,
		2076,
		9160
	],
	"./ion-nav_2.entry.js": [
		393,
		2076,
		393
	],
	"./ion-picker-column-option.entry.js": [
		8442,
		8442
	],
	"./ion-picker-column.entry.js": [
		3110,
		2076,
		3110
	],
	"./ion-picker.entry.js": [
		5575,
		5575
	],
	"./ion-popover.entry.js": [
		6772,
		2076,
		6772
	],
	"./ion-progress-bar.entry.js": [
		4810,
		4810
	],
	"./ion-radio_2.entry.js": [
		4639,
		2076,
		4639
	],
	"./ion-range.entry.js": [
		628,
		2076,
		628
	],
	"./ion-refresher_2.entry.js": [
		852,
		2076,
		852
	],
	"./ion-reorder_2.entry.js": [
		1479,
		2076,
		1479
	],
	"./ion-ripple-effect.entry.js": [
		4065,
		4065
	],
	"./ion-route_4.entry.js": [
		7971,
		7971
	],
	"./ion-searchbar.entry.js": [
		3184,
		2076,
		3184
	],
	"./ion-segment-content.entry.js": [
		4312,
		4312
	],
	"./ion-segment-view.entry.js": [
		4540,
		4540
	],
	"./ion-segment_2.entry.js": [
		469,
		2076,
		469
	],
	"./ion-select-modal.entry.js": [
		7101,
		7101
	],
	"./ion-select_3.entry.js": [
		8471,
		2076,
		8471
	],
	"./ion-spinner.entry.js": [
		388,
		2076,
		388
	],
	"./ion-split-pane.entry.js": [
		2392,
		2392
	],
	"./ion-tab-bar_2.entry.js": [
		6059,
		2076,
		6059
	],
	"./ion-tab_2.entry.js": [
		5427,
		5427
	],
	"./ion-text.entry.js": [
		198,
		198
	],
	"./ion-textarea.entry.js": [
		1735,
		2076,
		1735
	],
	"./ion-toast.entry.js": [
		5129,
		2076,
		7510
	],
	"./ion-toggle.entry.js": [
		5297,
		2076,
		5297
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8996;
module.exports = webpackAsyncContext;